import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnkashCardsService } from '@app-service/enkash-cards.service';
import { UserService } from '@app-service/user.service';
import { TRCKING_TYPE } from 'core/constants';
import { TrackingService } from 'core/services/tracking.service';

@Component({
    selector: 'app-redeem-rewards-popup',
    templateUrl: './redeem-rewards-popup.component.html',
    styleUrls: ['./redeem-rewards-popup.component.scss'],
    standalone: false
})
export class RedeemRewardsPopupComponent implements OnInit {

  @Input() balance: number = 0;
  @Input() name: string = '';
  @Input() accountType: string;
  isBlockedOrLockedCardFlag = false;

  constructor(
    private router: Router,
    private trackingService: TrackingService,
    private userService: UserService,
    private cardService: EnkashCardsService
  ) { }

  ngOnInit(): void {
    this.isBlockedOrLockedCard();
  }

  isBlockedOrLockedCard() {
    const data = {
      companyId: this.userService.currentUser.companyId,
      accountType: this.accountType,
      userId: this.userService.currentUser.userId,
    };
    this.cardService.getEnkashCardsByFilter(data).subscribe(
      (res) => {
        this.isBlockedOrLockedCardFlag = res.data[0].cardStatus?.name === 'BL' || res.data[0].cardStatus?.name === 'L';
      })
  }

  redeemVouchers() {
    this.trackingService.track(TRCKING_TYPE.EVENT, 'rewards_popup_redeem_now', {}); 

    if (this.accountType === 'EMPLOYEE_REWARDS') {
      this.router.navigate(['/marketplace/dashboard'], { queryParams :  { program : 'employee_rewards' } });
    }
    else if (this.accountType === 'CHANNEL_INCENTIVE') {
      this.router.navigate(['/marketplace/dashboard'], { queryParams :  { program : 'channel_incentive' } });
    }
  }

}
